module.exports = __webpack_public_path__ + "img/KinokoTable61.0e029456.jpg";